import React, {
  useState,
  useEffect,
  useRef,
  useCallback
} from "react";

import { useNavigate, useParams } from "react-router-dom";
import {
  FaArrowLeft,
  FaPaperPlane
} from "react-icons/fa";

import { toast } from "react-toastify";
import api from "../utils/api";
import "./ComplaintChatPage.css";

export default function ComplaintChatPage() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const bottomRef = useRef(null);

  const loadMessages = useCallback(async () => {

    try {

      console.log("Loading complaint:", id);

      const res = await api.get(
        `/complaints/messages/${id}`
      );

      console.log("Message Response:", res.data);

      let list = [];

      if (Array.isArray(res.data)) {
        list = res.data;
      } else if (Array.isArray(res.data.data)) {
        list = res.data.data;
      } else if (Array.isArray(res.data.messages)) {
        list = res.data.messages;
      }

      setMessages(list);

    } catch (err) {

      console.error("CHAT ERROR", err);

      if (err.response) {
        console.log("Status:", err.response.status);
        console.log("Data:", err.response.data);
      }

      toast.error("Unable to load messages");

    } finally {

      setLoading(false);

    }

  }, [id]);

  useEffect(() => {

    loadMessages();

    const timer = setInterval(() => {
      loadMessages();
    }, 3000);

    return () => clearInterval(timer);

  }, [loadMessages]);

  useEffect(() => {

    bottomRef.current?.scrollIntoView({
      behavior: "smooth"
    });

  }, [messages]);

  const sendMessage = async () => {

    if (!message.trim()) return;

    try {

      await api.post(
        "/complaints/messages",
        {
          complaintId: Number(id),
          message: message.trim()
        }
      );

      setMessage("");

      loadMessages();

    } catch (err) {

      console.error(err);

      toast.error(
        err.response?.data?.message ||
        "Failed to send message"
      );

    }

  };

  if (loading) {

    return (
      <div className="chat-loading">
        Loading chat...
      </div>
    );

  }

  return (

    <div className="chat-page">

      <div className="chat-header">

        <button
          className="back-btn"
          onClick={() => navigate("/dashboard")}
        >
          <FaArrowLeft />
        </button>

        <div>

          <h2>Complaint Chat</h2>

          <small>
            Complaint #{id}
          </small>

        </div>

      </div>

      <div className="chat-body">

        {messages.length === 0 && (

          <div
            style={{
              textAlign: "center",
              marginTop: 40,
              color: "#888"
            }}
          >
            No messages yet
          </div>

        )}

        {messages.map((item) => {

          const isCitizen =
            item.senderRole === "CITIZEN";

          return (

            <div
              key={item.id}
              className={`message-row ${
                isCitizen
                  ? "right"
                  : "left"
              }`}
            >

              <div
                className={`message-bubble ${
                  isCitizen
                    ? "citizen"
                    : "corporator"
                }`}
              >

                <div>{item.message}</div>

                <span>

                  {item.senderRole}

                  {item.createdAt &&
                    " • " +
                      new Date(
                        item.createdAt
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit"
                      })}

                </span>

              </div>

            </div>

          );

        })}

        <div ref={bottomRef}></div>

      </div>

      <div className="chat-footer">

        <input
          value={message}
          placeholder="Type message..."
          onChange={(e) =>
            setMessage(e.target.value)
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              sendMessage();
            }
          }}
        />

        <button onClick={sendMessage}>
          <FaPaperPlane />
        </button>

      </div>

    </div>

  );

}